import { render, staticRenderFns } from "./LongTextAttribute.vue?vue&type=template&id=22b4b6b1"
import script from "./LongTextAttribute.vue?vue&type=script&lang=js"
export * from "./LongTextAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports